

// import React, { useState, useCallback, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { MainLayout } from '../layout/MainLayout';
// import { 
//   Download, 
//   Upload, 
//   CheckCircle, 
//   XCircle, 
//   Loader, 
//   FileText, 
//   ArrowLeft, 
//   ArrowRight,
//   AlertCircle,
//   Trash2,
//   FileUp,
//   FolderOpen
// } from 'lucide-react';
// import apiClient from '../utils/apiClient';
// import PrimaryButton from "../ui/PrimaryButton";
// import { ActionButton } from "../ui/ActionButton";
// import { Toast } from '../ui/Toast';

// // Reusable Components
// const PageHeader = ({ 
//   icon: Icon, 
//   title, 
//   subtitle, 
//   iconGradient = "from-blue-600 to-indigo-600",
//   projectId,
//   projectName
// }) => (
//   <div className="text-center mb-8">
//     <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
//       <Icon className="w-8 h-8 text-white" />
//     </div>
//     <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
//       {title}
//     </h1>
//     {projectId && (
//       <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg mb-3">
//         <FolderOpen className="w-4 h-4 text-blue-600" />
//         <span className="font-semibold text-blue-800">
//           Project: {projectName || projectId}
//         </span>
//       </div>
//     )}
//     <p className="text-base text-slate-600 max-w-2xl mx-auto">
//       {subtitle}
//     </p>
//   </div>
// );

// const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
//   <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6 ${className}`}>
//     <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
//       <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
//       <div className="relative z-10 flex items-center gap-3">
//         <Icon className="w-5 h-5 text-white" />
//         <h2 className="text-lg font-bold text-white">{title}</h2>
//       </div>
      
//       {/* Decorative Elements */}
//       <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
//       <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
//     </div>
    
//     <div className="p-6">
//       {children}
//     </div>
//   </div>
// );

// const ProgressBar = ({ uploadedCount, totalFiles }) => {
//   if (uploadedCount === 0) return null;
  
//   const percentage = (uploadedCount / totalFiles) * 100;
  
//   return (
//     <div className="mb-6">
//       <div className="flex justify-between items-center mb-3">
//         <span className="text-sm font-semibold text-slate-700">Upload Progress</span>
//         <span className="text-sm font-bold text-blue-600">{uploadedCount}/{totalFiles} files</span>
//       </div>
//       <div className="w-full bg-slate-200 rounded-full h-3 shadow-inner">
//         <div 
//           className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all duration-500 shadow-sm"
//           style={{ width: `${percentage}%` }}
//         />
//       </div>
//       <div className="text-center mt-2">
//         <span className="text-xs text-slate-500">{Math.round(percentage)}% Complete</span>
//       </div>
//     </div>
//   );
// };

// const FileUploadItem = ({ fileItem, onUpload, onRemove }) => {
//   const handleUpload = () => {
//     const input = document.createElement('input');
//     input.type = 'file';
//     input.accept = '.stl';
//     input.onchange = (e) => {
//       const file = e.target.files[0];
//       if (file) onUpload(fileItem.name, file);
//     };
//     input.click();
//   };

//   const getStatusDisplay = () => {
//     if (fileItem.progress === 'Complete') {
//       return {
//         icon: <CheckCircle className="w-5 h-5 text-green-600" />,
//         text: 'Uploaded',
//         color: 'text-green-600'
//       };
//     }
//     if (fileItem.progress === 'Failed') {
//       return {
//         icon: <XCircle className="w-5 h-5 text-red-600" />,
//         text: 'Failed',
//         color: 'text-red-600'
//       };
//     }
//     if (fileItem.progress) {
//       return {
//         icon: <Loader className="w-5 h-5 text-blue-600 animate-spin" />,
//         text: fileItem.progress,
//         color: 'text-blue-600'
//       };
//     }
//     return null;
//   };

//   const getCardStyle = () => {
//     if (fileItem.uploaded) return 'border-green-300 bg-green-50 shadow-md';
//     if (fileItem.progress) return 'border-blue-300 bg-blue-50 shadow-md';
//     return 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md';
//   };

//   const status = getStatusDisplay();

//   return (
//     <div className={`group border-2 rounded-xl p-4 transition-all duration-200 ${getCardStyle()}`}>
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{fileItem.displayName}</div>
//             <div className="text-sm text-slate-500">{fileItem.name}</div>
//             {fileItem.file && (
//               <div className="text-xs text-slate-400 mt-1">
//                 {fileItem.file.name} ({(fileItem.file.size / (1024 * 1024)).toFixed(2)} MB)
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           {status && (
//             <div className="flex items-center gap-2">
//               {status.icon}
//               <span className={`text-sm font-medium ${status.color}`}>
//                 {status.text}
//               </span>
//             </div>
//           )}

//           <div className="flex items-center gap-2">
//             {fileItem.uploaded && !fileItem.progress && (
//               <button
//                 onClick={() => onRemove(fileItem.name)}
//                 className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
//                 title="Remove file"
//               >
//                 <Trash2 className="w-4 h-4" />
//               </button>
//             )}
            
//             <button
//               onClick={handleUpload}
//               disabled={fileItem.uploaded || fileItem.progress}
//               className={`p-3 rounded-lg transition-all duration-200 ${
//                 fileItem.uploaded || fileItem.progress
//                   ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                   : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//               }`}
//               title={fileItem.uploaded ? 'File already uploaded' : 'Upload file'}
//             >
//               <Upload className="w-5 h-5" />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Custom hook to fetch project name
// const useProjectName = (projectId) => {
//   const [projectName, setProjectName] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectName = async () => {
//       if (!projectId) return;

//       try {
//         setIsLoading(true);
//         setError(null);
        
//         const data = await apiClient.get(`/api/projects/${projectId}/`, {
//           showToast: false,
//         });

//         setProjectName(data.name);
//       } catch (err) {
//         console.error('Error fetching project name:', err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchProjectName();
//   }, [projectId]);

//   return { projectName, isLoading, error };
// };

// // Flexible file upload hook with customizable path
// const useCustomFileUpload = (projectId, projectName, options = {}) => {
//   const {
//     initialFiles = [
//       { name: 'surrounding_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Surrounding Buildings' },
//       { name: 'target_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Target Buildings' },
//       { name: 'terrain.stl', uploaded: false, file: null, progress: null, displayName: 'Terrain' },
//       { name: 'vegetation.stl', uploaded: false, file: null, progress: null, displayName: 'Vegetation' }
//     ],
    
//     pathTemplate = 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//     // pathTemplate = 'raytracing/raytracing/Projects/${projectName}/01_Input/GeospatialData/STLfiles/02_Final_version/${fileName}',
//     endpoint = '/api/files/upload-form',
//     fileExtensions = ['.stl'],
//     useOperational = true,
//     overwrite = true
//   } = options;

//   const [files, setFiles] = useState(initialFiles);

//   const allFilesUploaded = files.every(file => file.uploaded);
//   const uploadedCount = files.filter(file => file.uploaded).length;

//   const updateFileProgress = useCallback((fileName, progress) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, progress } : f));
//   }, []);

//   const markFileUploaded = useCallback((fileName, file) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: true, file, progress: 'Complete' } : f));
//   }, []);

//   const removeFile = useCallback((fileName) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: false, file: null, progress: null } : f));
//   }, []);

//   const uploadFile = useCallback(async (fileName, selectedFile) => {
//     if (!projectId) throw new Error('Project ID is missing');
//     if (!projectName) throw new Error('Project name is missing');
    
//     // Check file extension
//     const hasValidExtension = fileExtensions.some(ext => 
//       selectedFile.name.toLowerCase().endsWith(ext.toLowerCase())
//     );
//     if (!hasValidExtension) {
//       throw new Error(`Please select a valid file. Allowed extensions: ${fileExtensions.join(', ')}`);
//     }

//     updateFileProgress(fileName, 'Uploading file...');
    
//     // Generate destination path using template
//     const destPath = pathTemplate
//       .replace('${projectName}', projectName)
//       .replace('${fileName}', fileName)
//       .replace('${projectId}', projectId);
    
//     await apiClient.uploadFile(endpoint, selectedFile, {
//       destPath,
//       overwrite: overwrite.toString(),
//     }, {
//       useOperational,
//       showToast: false,
//     });

//     markFileUploaded(fileName, selectedFile);
//     setTimeout(() => updateFileProgress(fileName, null), 2000);
//   }, [projectId, projectName, updateFileProgress, markFileUploaded, pathTemplate, endpoint, fileExtensions, useOperational, overwrite]);

//   return { files, allFilesUploaded, uploadedCount, uploadFile, removeFile, setFiles };
// };

// // Backward compatibility hook - uses the original behavior
// const useFileUpload = (projectId, projectName) => {
//   return useCustomFileUpload(projectId, projectName, {
//     pathTemplate: 'raytracing/raytracing/Projects/${projectName}DigitalTwin/STLfiles/02_Final_version/${fileName}',
//     endpoint: '/api/files/upload-form',
//     fileExtensions: ['.stl'],
//     useOperational: true,
//     overwrite: true
//   });
// };

// const useToast = () => {
//   const [toast, setToast] = useState(null);

//   const showToast = useCallback((message, type = 'info') => {
//     setToast({ message, type });
//     if (type !== 'loading') {
//       setTimeout(() => setToast(null), 3000);
//     }
//   }, []);

//   const hideToast = useCallback(() => setToast(null), []);

//   return { toast, showToast, hideToast };
// };

// // Main Component
// const CheckOutputFilesPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();
//   const { toast, showToast, hideToast } = useToast();
  
//   // Use the project name hook
//   const { projectName, isLoading: isLoadingProject, error: projectError } = useProjectName(projectId);
  
//   // Use custom file upload hook with specific path for output files
//   const { files, allFilesUploaded, uploadedCount, uploadFile, removeFile } = useCustomFileUpload(
//     projectId, 
//     projectName, 
//     {
      
//       pathTemplate: 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//       endpoint: '/api/files/upload-form',
//       fileExtensions: ['.stl'],
//       useOperational: true,
//       overwrite: true
//     }
//   );
  
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [isProcessing, setIsProcessing] = useState(false);

//   // Show error if project fetch fails
//   useEffect(() => {
//     if (projectError) {
//       showToast(`Error loading project: ${projectError}`, 'error');
//     }
//   }, [projectError, showToast]);

//   const handleBackToMenu = useCallback(() => {
//     navigate(`/project-processing/${projectId}`);
//   }, [navigate, projectId]);

//   const handleDownloadFiles = useCallback(async () => {
//     if (!projectId) {
//       showToast('Project ID is missing', 'error');
//       return;
//     }

//     if (!projectName) {
//       showToast('Project name is missing', 'error');
//       return;
//     }

//     setIsDownloading(true);
//     showToast('Downloading files...', 'loading');
    
//     try {
//       // Use the new path structure with projectName
//       const downloadPath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/`;
      
//       // Note: This might need to be a blob response for file downloads
//       // You may need to handle the response differently based on your API
//       const response = await apiClient.get(`/api/directories/download/${downloadPath}`, {
//         showToast: false,
//         useOperational: true,
//       });

//       // Handle the response as a blob for file download
//       const blob = new Blob([response]);
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `${projectName}_output_files.zip`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       showToast('Files downloaded successfully!', 'success');
//     } catch (error) {
//       console.error('Download failed:', error);
//       showToast('Download failed. Please try again.', 'error');
//     } finally {
//       setIsDownloading(false);
//     }
//   }, [projectId, projectName, showToast]);

//   const handleFileUpload = useCallback(async (fileName, file) => {
//     try {
//       await uploadFile(fileName, file);
//       showToast(`${fileName} uploaded successfully!`, 'success');
//     } catch (error) {
//       console.error('Error uploading STL file:', error);
//       showToast(`Failed to upload ${fileName}. Please try again.`, 'error');
//     }
//   }, [uploadFile, showToast]);

//   const handleRemoveFile = useCallback((fileName) => {
//     removeFile(fileName);
//     showToast('File removed successfully.', 'success');
//   }, [removeFile, showToast]);

//   const handleNext = useCallback(async () => {
//     if (!allFilesUploaded) {
//       showToast('Please upload all files before proceeding.', 'error');
//       return;
//     }

//     setIsProcessing(true);
//     showToast('Processing files...', 'loading');

//     try {
//       await new Promise(resolve => setTimeout(resolve, 2000));
//       showToast('Files processed successfully!', 'success');
//       navigate(`/project-processing/${projectId}`);
//     } catch (error) {
//       console.error('Processing failed:', error);
//       showToast('Processing failed. Please try again.', 'error');
//     } finally {
//       setIsProcessing(false);
//     }
//   }, [allFilesUploaded, projectId, navigate, showToast]);

//   // Show loading state while fetching project name
//   if (isLoadingProject) {
//     return (
//       <MainLayout>
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//           <div className="max-w-4xl mx-auto">
//             <div className="text-center">
//               <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
//               <p className="text-slate-600">Loading project information...</p>
//             </div>
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//         {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
        
//         <div className="max-w-4xl mx-auto">
//           <PageHeader
//             icon={FileUp}
//             title="Check Output Files"
//             subtitle="Review, download, and upload your processed STL files to continue with the project workflow"
//             projectId={projectId}
//             projectName={projectName}
//           />

//           {/* Back Button */}
//           <div className="flex justify-center mb-8">
//             <button
//               onClick={handleBackToMenu}
//               className="group bg-white hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg border border-slate-200"
//             >
//               <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
//               BACK TO MENU
//             </button>
//           </div>

//           {/* Progress Overview */}
//           {uploadedCount > 0 && (
//             <SectionCard
//               title="Upload Progress"
//               icon={FileUp}
//               gradient="from-blue-600 to-indigo-600"
//             >
//               <ProgressBar uploadedCount={uploadedCount} totalFiles={files.length} />
//             </SectionCard>
//           )}

//           {/* Download Section */}
//           <SectionCard
//             title="Download Output Files"
//             icon={Download}
//             gradient="from-indigo-600 to-purple-600"
//           >
//             <div className="text-center">
//               <p className="text-slate-600 mb-6">
//                 Download the generated output files, review them, and make any necessary adjustments before uploading.
//               </p>
//               <button
//                 onClick={handleDownloadFiles}
//                 disabled={isDownloading}
//                 className="group bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
//               >
//                 {isDownloading ? (
//                   <>
//                     <Loader className="w-5 h-5 animate-spin" />
//                     Downloading...
//                   </>
//                 ) : (
//                   <>
//                     <Download className="w-5 h-5" />
//                     Download All Files
//                   </>
//                 )}
//               </button>
//             </div>
//           </SectionCard>

//           {/* Upload Section */}
//           <SectionCard
//             title="Upload Modified Files"
//             icon={Upload}
//             gradient="from-purple-600 to-pink-600"
//           >
//             <div className="space-y-4">
//               {files.map((fileItem, index) => (
//                 <FileUploadItem 
//                   key={index} 
//                   fileItem={fileItem} 
//                   onUpload={handleFileUpload} 
//                   onRemove={handleRemoveFile} 
//                 />
//               ))}
//             </div>

//             {!allFilesUploaded && (
//               <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
//                 <div className="flex items-start gap-3">
//                   <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
//                   <div>
//                     <h4 className="font-semibold text-amber-800 mb-1">Upload Required</h4>
//                     <p className="text-amber-700 text-sm">
//                       Please upload all {files.length} STL files ({uploadedCount}/{files.length} completed) to continue to the next step.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </SectionCard>

//           {/* Next Button */}
//           <div className="text-center">
//             <button
//               onClick={handleNext}
//               disabled={!allFilesUploaded || isProcessing || !projectName}
//               className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
//             >
//               {isProcessing ? (
//                 <>
//                   <Loader className="w-5 h-5 animate-spin" />
//                   Processing Files...
//                 </>
//               ) : (
//                 <>
//                   {allFilesUploaded ? 'Continue to Next Step' : `Upload Remaining Files (${uploadedCount}/${files.length})`}
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default CheckOutputFilesPage;
// import React, { useState, useCallback, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { MainLayout } from '../layout/MainLayout';
// import { 
//   Download, 
//   Upload, 
//   CheckCircle, 
//   XCircle, 
//   Loader, 
//   FileText, 
//   ArrowLeft, 
//   ArrowRight,
//   AlertCircle,
//   Trash2,
//   FileUp,
//   FolderOpen,
//   RefreshCw
// } from 'lucide-react';
// import apiClient from '../utils/apiClient';
// import PrimaryButton from "../ui/PrimaryButton";
// import { ActionButton } from "../ui/ActionButton";
// import { Toast } from '../ui/Toast';

// // Reusable Components
// const PageHeader = ({ 
//   icon: Icon, 
//   title, 
//   subtitle, 
//   iconGradient = "from-blue-600 to-indigo-600",
//   projectId,
//   projectName
// }) => (
//   <div className="text-center mb-8">
//     <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
//       <Icon className="w-8 h-8 text-white" />
//     </div>
//     <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
//       {title}
//     </h1>
//     {projectId && (
//       <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg mb-3">
//         <FolderOpen className="w-4 h-4 text-blue-600" />
//         <span className="font-semibold text-blue-800">
//           Project: {projectName || projectId}
//         </span>
//       </div>
//     )}
//     <p className="text-base text-slate-600 max-w-2xl mx-auto">
//       {subtitle}
//     </p>
//   </div>
// );

// const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
//   <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6 ${className}`}>
//     <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
//       <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
//       <div className="relative z-10 flex items-center gap-3">
//         <Icon className="w-5 h-5 text-white" />
//         <h2 className="text-lg font-bold text-white">{title}</h2>
//       </div>
      
//       {/* Decorative Elements */}
//       <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
//       <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
//     </div>
    
//     <div className="p-6">
//       {children}
//     </div>
//   </div>
// );

// const ProgressBar = ({ uploadedCount, totalFiles }) => {
//   if (uploadedCount === 0) return null;
  
//   const percentage = (uploadedCount / totalFiles) * 100;
  
//   return (
//     <div className="mb-6">
//       <div className="flex justify-between items-center mb-3">
//         <span className="text-sm font-semibold text-slate-700">Upload Progress</span>
//         <span className="text-sm font-bold text-blue-600">{uploadedCount}/{totalFiles} files</span>
//       </div>
//       <div className="w-full bg-slate-200 rounded-full h-3 shadow-inner">
//         <div 
//           className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all duration-500 shadow-sm"
//           style={{ width: `${percentage}%` }}
//         />
//       </div>
//       <div className="text-center mt-2">
//         <span className="text-xs text-slate-500">{Math.round(percentage)}% Complete</span>
//       </div>
//     </div>
//   );
// };

// // New component for individual file download
// const DownloadFileItem = ({ file, onDownload, isDownloading }) => {
//   const getFileSize = (size) => {
//     if (!size) return 'Unknown size';
//     if (size < 1024) return `${size} B`;
//     if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
//     if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
//     return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Unknown date';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   return (
//     <div className="group border-2 border-slate-200 bg-white hover:border-slate-300 hover:shadow-md rounded-xl p-4 transition-all duration-200">
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{file.name}</div>
//             <div className="text-sm text-slate-500">
//               {getFileSize(file.size)} • Modified: {formatDate(file.modTime)}
//             </div>
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => onDownload(file.name)}
//             disabled={isDownloading}
//             className={`p-3 rounded-lg transition-all duration-200 flex items-center gap-2 ${
//               isDownloading
//                 ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                 : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//             }`}
//             title="Download file"
//           >
//             {isDownloading ? (
//               <>
//                 <Loader className="w-4 h-4 animate-spin" />
//                 <span className="text-sm font-medium">Downloading...</span>
//               </>
//             ) : (
//               <>
//                 <Download className="w-4 h-4" />
//                 <span className="text-sm font-medium">Download</span>
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const FileUploadItem = ({ fileItem, onUpload, onRemove }) => {
//   const handleUpload = () => {
//     const input = document.createElement('input');
//     input.type = 'file';
//     input.accept = '.stl';
//     input.onchange = (e) => {
//       const file = e.target.files[0];
//       if (file) onUpload(fileItem.name, file);
//     };
//     input.click();
//   };

//   const getStatusDisplay = () => {
//     if (fileItem.progress === 'Complete') {
//       return {
//         icon: <CheckCircle className="w-5 h-5 text-green-600" />,
//         text: 'Uploaded',
//         color: 'text-green-600'
//       };
//     }
//     if (fileItem.progress === 'Failed') {
//       return {
//         icon: <XCircle className="w-5 h-5 text-red-600" />,
//         text: 'Failed',
//         color: 'text-red-600'
//       };
//     }
//     if (fileItem.progress) {
//       return {
//         icon: <Loader className="w-5 h-5 text-blue-600 animate-spin" />,
//         text: fileItem.progress,
//         color: 'text-blue-600'
//       };
//     }
//     return null;
//   };

//   const getCardStyle = () => {
//     if (fileItem.uploaded) return 'border-green-300 bg-green-50 shadow-md';
//     if (fileItem.progress) return 'border-blue-300 bg-blue-50 shadow-md';
//     return 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md';
//   };

//   const status = getStatusDisplay();

//   return (
//     <div className={`group border-2 rounded-xl p-4 transition-all duration-200 ${getCardStyle()}`}>
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{fileItem.displayName}</div>
//             <div className="text-sm text-slate-500">{fileItem.name}</div>
//             {fileItem.file && (
//               <div className="text-xs text-slate-400 mt-1">
//                 {fileItem.file.name} ({(fileItem.file.size / (1024 * 1024)).toFixed(2)} MB)
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           {status && (
//             <div className="flex items-center gap-2">
//               {status.icon}
//               <span className={`text-sm font-medium ${status.color}`}>
//                 {status.text}
//               </span>
//             </div>
//           )}

//           <div className="flex items-center gap-2">
//             {fileItem.uploaded && !fileItem.progress && (
//               <button
//                 onClick={() => onRemove(fileItem.name)}
//                 className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
//                 title="Remove file"
//               >
//                 <Trash2 className="w-4 h-4" />
//               </button>
//             )}
            
//             <button
//               onClick={handleUpload}
//               disabled={fileItem.uploaded || fileItem.progress}
//               className={`p-3 rounded-lg transition-all duration-200 ${
//                 fileItem.uploaded || fileItem.progress
//                   ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                   : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//               }`}
//               title={fileItem.uploaded ? 'File already uploaded' : 'Upload file'}
//             >
//               <Upload className="w-5 h-5" />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Custom hook to fetch project name
// const useProjectName = (projectId) => {
//   const [projectName, setProjectName] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectName = async () => {
//       if (!projectId) return;

//       try {
//         setIsLoading(true);
//         setError(null);
        
//         const data = await apiClient.get(`/api/projects/${projectId}/`, {
//           showToast: false,
//         });

//         setProjectName(data.name);
//       } catch (err) {
//         console.error('Error fetching project name:', err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchProjectName();
//   }, [projectId]);

//   return { projectName, isLoading, error };
// };

// // Custom hook to list files in directory
// const useFileList = (projectName) => {
//   const [files, setFiles] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchFiles = useCallback(async () => {
//     if (!projectName) return;

//     setIsLoading(true);
//     setError(null);

//     try {
//       // Construct the path properly - the API expects everything after /api/list/ as the path parameter
//       const listPath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version`;
      
//       const response = await apiClient.get(`/api/list/${listPath}`, {
//         showToast: false,
//         useOperational: true,
//       });

//       // Filter for STL files only
//       const stlFiles = response.files?.filter(file => 
//         file.name.toLowerCase().endsWith('.stl')
//       ) || [];

//       setFiles(stlFiles);
//     } catch (err) {
//       console.error('Error fetching file list:', err);
//       setError(err.message);
//       setFiles([]);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [projectName]);

//   useEffect(() => {
//     fetchFiles();
//   }, [fetchFiles]);

//   return { files, isLoading, error, refetch: fetchFiles };
// };

// // Flexible file upload hook with customizable path
// const useCustomFileUpload = (projectId, projectName, options = {}) => {
//   const {
//     initialFiles = [
//       { name: 'surrounding_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Surrounding Buildings' },
//       { name: 'target_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Target Buildings' },
//       { name: 'terrain.stl', uploaded: false, file: null, progress: null, displayName: 'Terrain' },
//       { name: 'vegetation.stl', uploaded: false, file: null, progress: null, displayName: 'Vegetation' }
//     ],
    
//     pathTemplate = 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//     endpoint = '/api/files/upload-form',
//     fileExtensions = ['.stl'],
//     useOperational = true,
//     overwrite = true
//   } = options;

//   const [files, setFiles] = useState(initialFiles);

//   const allFilesUploaded = files.every(file => file.uploaded);
//   const uploadedCount = files.filter(file => file.uploaded).length;

//   const updateFileProgress = useCallback((fileName, progress) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, progress } : f));
//   }, []);

//   const markFileUploaded = useCallback((fileName, file) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: true, file, progress: 'Complete' } : f));
//   }, []);

//   const removeFile = useCallback((fileName) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: false, file: null, progress: null } : f));
//   }, []);

//   const uploadFile = useCallback(async (fileName, selectedFile) => {
//     if (!projectId) throw new Error('Project ID is missing');
//     if (!projectName) throw new Error('Project name is missing');
    
//     // Check file extension
//     const hasValidExtension = fileExtensions.some(ext => 
//       selectedFile.name.toLowerCase().endsWith(ext.toLowerCase())
//     );
//     if (!hasValidExtension) {
//       throw new Error(`Please select a valid file. Allowed extensions: ${fileExtensions.join(', ')}`);
//     }

//     updateFileProgress(fileName, 'Uploading file...');
    
//     // Generate destination path using template
//     const destPath = pathTemplate
//       .replace('${projectName}', projectName)
//       .replace('${fileName}', fileName)
//       .replace('${projectId}', projectId);
    
//     await apiClient.uploadFile(endpoint, selectedFile, {
//       destPath,
//       overwrite: overwrite.toString(),
//     }, {
//       useOperational,
//       showToast: false,
//     });

//     markFileUploaded(fileName, selectedFile);
//     setTimeout(() => updateFileProgress(fileName, null), 2000);
//   }, [projectId, projectName, updateFileProgress, markFileUploaded, pathTemplate, endpoint, fileExtensions, useOperational, overwrite]);

//   return { files, allFilesUploaded, uploadedCount, uploadFile, removeFile, setFiles };
// };

// const useToast = () => {
//   const [toast, setToast] = useState(null);

//   const showToast = useCallback((message, type = 'info') => {
//     setToast({ message, type });
//     if (type !== 'loading') {
//       setTimeout(() => setToast(null), 3000);
//     }
//   }, []);

//   const hideToast = useCallback(() => setToast(null), []);

//   return { toast, showToast, hideToast };
// };

// // Main Component
// const CheckOutputFilesPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();
//   const { toast, showToast, hideToast } = useToast();
  
//   // Use the project name hook
//   const { projectName, isLoading: isLoadingProject, error: projectError } = useProjectName(projectId);
  
//   // Use file list hook to get available files
//   const { files: availableFiles, isLoading: isLoadingFiles, error: filesError, refetch: refetchFiles } = useFileList(projectName);
  
//   // Use custom file upload hook with specific path for output files
//   const { files, allFilesUploaded, uploadedCount, uploadFile, removeFile } = useCustomFileUpload(
//     projectId, 
//     projectName, 
//     {
//       pathTemplate: 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//       endpoint: '/api/files/upload-form',
//       fileExtensions: ['.stl'],
//       useOperational: true,
//       overwrite: true
//     }
//   );
  
//   const [downloadingFiles, setDownloadingFiles] = useState(new Set());
//   const [isProcessing, setIsProcessing] = useState(false);

//   // Show error if project fetch fails
//   useEffect(() => {
//     if (projectError) {
//       showToast(`Error loading project: ${projectError}`, 'error');
//     }
//   }, [projectError, showToast]);

//   // Show error if file listing fails
//   useEffect(() => {
//     if (filesError) {
//       showToast(`Error loading files: ${filesError}`, 'error');
//     }
//   }, [filesError, showToast]);

//   const handleBackToMenu = useCallback(() => {
//     navigate(`/project-processing/${projectId}`);
//   }, [navigate, projectId]);

//   const handleDownloadFile = useCallback(async (fileName) => {
//     if (!projectName) {
//       showToast('Project name is missing', 'error');
//       return;
//     }

//     setDownloadingFiles(prev => new Set(prev).add(fileName));
//     showToast(`Downloading ${fileName}...`, 'loading');
    
//     try {
//       // Construct the file path properly for the download API
//       const filePath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}`;
      
//       const response = await fetch(`/api/files/download/${filePath}`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('token')}`, // Adjust based on your auth setup
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to download file: ${response.statusText}`);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       showToast(`${fileName} downloaded successfully!`, 'success');
//     } catch (error) {
//       console.error('Download failed:', error);
//       showToast(`Failed to download ${fileName}. Please try again.`, 'error');
//     } finally {
//       setDownloadingFiles(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(fileName);
//         return newSet;
//       });
//     }
//   }, [projectName, showToast]);

//   const handleRefreshFiles = useCallback(() => {
//     refetchFiles();
//     showToast('File list refreshed', 'success');
//   }, [refetchFiles, showToast]);

//   const handleFileUpload = useCallback(async (fileName, file) => {
//     try {
//       await uploadFile(fileName, file);
//       showToast(`${fileName} uploaded successfully!`, 'success');
//       // Refresh the file list after upload
//       setTimeout(() => refetchFiles(), 1000);
//     } catch (error) {
//       console.error('Error uploading STL file:', error);
//       showToast(`Failed to upload ${fileName}. Please try again.`, 'error');
//     }
//   }, [uploadFile, showToast, refetchFiles]);

//   const handleRemoveFile = useCallback((fileName) => {
//     removeFile(fileName);
//     showToast('File removed successfully.', 'success');
//   }, [removeFile, showToast]);

//   const handleNext = useCallback(async () => {
//     if (!allFilesUploaded) {
//       showToast('Please upload all files before proceeding.', 'error');
//       return;
//     }

//     setIsProcessing(true);
//     showToast('Processing files...', 'loading');

//     try {
//       await new Promise(resolve => setTimeout(resolve, 2000));
//       showToast('Files processed successfully!', 'success');
//       navigate(`/project-processing/${projectId}`);
//     } catch (error) {
//       console.error('Processing failed:', error);
//       showToast('Processing failed. Please try again.', 'error');
//     } finally {
//       setIsProcessing(false);
//     }
//   }, [allFilesUploaded, projectId, navigate, showToast]);

//   // Show loading state while fetching project name
//   if (isLoadingProject) {
//     return (
//       <MainLayout>
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//           <div className="max-w-4xl mx-auto">
//             <div className="text-center">
//               <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
//               <p className="text-slate-600">Loading project information...</p>
//             </div>
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//         {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
        
//         <div className="max-w-4xl mx-auto">
//           <PageHeader
//             icon={FileUp}
//             title="Check Output Files"
//             subtitle="Review, download, and upload your processed STL files to continue with the project workflow"
//             projectId={projectId}
//             projectName={projectName}
//           />

//           {/* Back Button */}
//           <div className="flex justify-center mb-8">
//             <button
//               onClick={handleBackToMenu}
//               className="group bg-white hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg border border-slate-200"
//             >
//               <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
//               BACK TO MENU
//             </button>
//           </div>

//           {/* Progress Overview */}
//           {uploadedCount > 0 && (
//             <SectionCard
//               title="Upload Progress"
//               icon={FileUp}
//               gradient="from-blue-600 to-indigo-600"
//             >
//               <ProgressBar uploadedCount={uploadedCount} totalFiles={files.length} />
//             </SectionCard>
//           )}

//           {/* Available Files Section */}
//           <SectionCard
//             title="Available Output Files"
//             icon={Download}
//             gradient="from-indigo-600 to-purple-600"
//           >
//             <div className="flex justify-between items-center mb-4">
//               <p className="text-slate-600">
//                 Download individual output files for review and modification.
//               </p>
//               <button
//                 onClick={handleRefreshFiles}
//                 disabled={isLoadingFiles}
//                 className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-all duration-200 disabled:opacity-50"
//               >
//                 <RefreshCw className={`w-4 h-4 ${isLoadingFiles ? 'animate-spin' : ''}`} />
//                 Refresh
//               </button>
//             </div>

//             {isLoadingFiles ? (
//               <div className="text-center py-8">
//                 <Loader className="w-6 h-6 text-blue-600 animate-spin mx-auto mb-2" />
//                 <p className="text-slate-600">Loading available files...</p>
//               </div>
//             ) : availableFiles.length > 0 ? (
//               <div className="space-y-3">
//                 {availableFiles.map((file, index) => (
//                   <DownloadFileItem 
//                     key={index} 
//                     file={file} 
//                     onDownload={handleDownloadFile}
//                     isDownloading={downloadingFiles.has(file.name)}
//                   />
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-8 text-slate-500">
//                 <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
//                 <p>No STL files found in the output directory.</p>
//                 <p className="text-sm mt-1">Files may still be processing or the directory may be empty.</p>
//               </div>
//             )}
//           </SectionCard>

//           {/* Upload Section */}
//           <SectionCard
//             title="Upload Modified Files"
//             icon={Upload}
//             gradient="from-purple-600 to-pink-600"
//           >
//             <div className="space-y-4">
//               {files.map((fileItem, index) => (
//                 <FileUploadItem 
//                   key={index} 
//                   fileItem={fileItem} 
//                   onUpload={handleFileUpload} 
//                   onRemove={handleRemoveFile} 
//                 />
//               ))}
//             </div>

//             {!allFilesUploaded && (
//               <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
//                 <div className="flex items-start gap-3">
//                   <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
//                   <div>
//                     <h4 className="font-semibold text-amber-800 mb-1">Upload Required</h4>
//                     <p className="text-amber-700 text-sm">
//                       Please upload all {files.length} STL files ({uploadedCount}/{files.length} completed) to continue to the next step.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </SectionCard>

//           {/* Next Button */}
//           <div className="text-center">
//             <button
//               onClick={handleNext}
//               disabled={!allFilesUploaded || isProcessing || !projectName}
//               className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
//             >
//               {isProcessing ? (
//                 <>
//                   <Loader className="w-5 h-5 animate-spin" />
//                   Processing Files...
//                 </>
//               ) : (
//                 <>
//                   {allFilesUploaded ? 'Continue to Next Step' : `Upload Remaining Files (${uploadedCount}/${files.length})`}
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default CheckOutputFilesPage;
// import React, { useState, useCallback, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { MainLayout } from '../layout/MainLayout';
// import { 
//   Download, 
//   Upload, 
//   CheckCircle, 
//   XCircle, 
//   Loader, 
//   FileText, 
//   ArrowLeft, 
//   ArrowRight,
//   AlertCircle,
//   Trash2,
//   FileUp,
//   FolderOpen,
//   RefreshCw
// } from 'lucide-react';
// import apiClient from '../utils/apiClient';
// import PrimaryButton from "../ui/PrimaryButton";
// import { ActionButton } from "../ui/ActionButton";
// import { Toast } from '../ui/Toast';

// // Reusable Components
// const PageHeader = ({ 
//   icon: Icon, 
//   title, 
//   subtitle, 
//   iconGradient = "from-blue-600 to-indigo-600",
//   projectId,
//   projectName
// }) => (
//   <div className="text-center mb-8">
//     <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
//       <Icon className="w-8 h-8 text-white" />
//     </div>
//     <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
//       {title}
//     </h1>
//     {projectId && (
//       <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg mb-3">
//         <FolderOpen className="w-4 h-4 text-blue-600" />
//         <span className="font-semibold text-blue-800">
//           Project: {projectName || projectId}
//         </span>
//       </div>
//     )}
//     <p className="text-base text-slate-600 max-w-2xl mx-auto">
//       {subtitle}
//     </p>
//   </div>
// );

// const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
//   <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6 ${className}`}>
//     <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
//       <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
//       <div className="relative z-10 flex items-center gap-3">
//         <Icon className="w-5 h-5 text-white" />
//         <h2 className="text-lg font-bold text-white">{title}</h2>
//       </div>
      
//       {/* Decorative Elements */}
//       <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
//       <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
//     </div>
    
//     <div className="p-6">
//       {children}
//     </div>
//   </div>
// );

// const ProgressBar = ({ uploadedCount, totalFiles }) => {
//   if (uploadedCount === 0) return null;
  
//   const percentage = (uploadedCount / totalFiles) * 100;
  
//   return (
//     <div className="mb-6">
//       <div className="flex justify-between items-center mb-3">
//         <span className="text-sm font-semibold text-slate-700">Upload Progress</span>
//         <span className="text-sm font-bold text-blue-600">{uploadedCount}/{totalFiles} files</span>
//       </div>
//       <div className="w-full bg-slate-200 rounded-full h-3 shadow-inner">
//         <div 
//           className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all duration-500 shadow-sm"
//           style={{ width: `${percentage}%` }}
//         />
//       </div>
//       <div className="text-center mt-2">
//         <span className="text-xs text-slate-500">{Math.round(percentage)}% Complete</span>
//       </div>
//     </div>
//   );
// };

// // New component for individual file download
// const DownloadFileItem = ({ file, onDownload, isDownloading }) => {
//   const getFileSize = (size) => {
//     if (!size) return 'Unknown size';
//     if (size < 1024) return `${size} B`;
//     if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
//     if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
//     return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Unknown date';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   return (
//     <div className="group border-2 border-slate-200 bg-white hover:border-slate-300 hover:shadow-md rounded-xl p-4 transition-all duration-200">
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{file.name}</div>
//             <div className="text-sm text-slate-500">
//               {getFileSize(file.size)} • Modified: {formatDate(file.lastModified)}
//             </div>
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => onDownload(file.name)}
//             disabled={isDownloading}
//             className={`p-3 rounded-lg transition-all duration-200 flex items-center gap-2 ${
//               isDownloading
//                 ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                 : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//             }`}
//             title="Download file"
//           >
//             {isDownloading ? (
//               <>
//                 <Loader className="w-4 h-4 animate-spin" />
//                 <span className="text-sm font-medium">Downloading...</span>
//               </>
//             ) : (
//               <>
//                 <Download className="w-4 h-4" />
//                 <span className="text-sm font-medium">Download</span>
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const FileUploadItem = ({ fileItem, onUpload, onRemove }) => {
//   const handleUpload = () => {
//     const input = document.createElement('input');
//     input.type = 'file';
//     input.accept = '.stl';
//     input.onchange = (e) => {
//       const file = e.target.files[0];
//       if (file) onUpload(fileItem.name, file);
//     };
//     input.click();
//   };

//   const getStatusDisplay = () => {
//     if (fileItem.progress === 'Complete') {
//       return {
//         icon: <CheckCircle className="w-5 h-5 text-green-600" />,
//         text: 'Uploaded',
//         color: 'text-green-600'
//       };
//     }
//     if (fileItem.progress === 'Failed') {
//       return {
//         icon: <XCircle className="w-5 h-5 text-red-600" />,
//         text: 'Failed',
//         color: 'text-red-600'
//       };
//     }
//     if (fileItem.progress) {
//       return {
//         icon: <Loader className="w-5 h-5 text-blue-600 animate-spin" />,
//         text: fileItem.progress,
//         color: 'text-blue-600'
//       };
//     }
//     return null;
//   };

//   const getCardStyle = () => {
//     if (fileItem.uploaded) return 'border-green-300 bg-green-50 shadow-md';
//     if (fileItem.progress) return 'border-blue-300 bg-blue-50 shadow-md';
//     return 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md';
//   };

//   const status = getStatusDisplay();

//   return (
//     <div className={`group border-2 rounded-xl p-4 transition-all duration-200 ${getCardStyle()}`}>
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{fileItem.displayName}</div>
//             <div className="text-sm text-slate-500">{fileItem.name}</div>
//             {fileItem.file && (
//               <div className="text-xs text-slate-400 mt-1">
//                 {fileItem.file.name} ({(fileItem.file.size / (1024 * 1024)).toFixed(2)} MB)
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           {status && (
//             <div className="flex items-center gap-2">
//               {status.icon}
//               <span className={`text-sm font-medium ${status.color}`}>
//                 {status.text}
//               </span>
//             </div>
//           )}

//           <div className="flex items-center gap-2">
//             {fileItem.uploaded && !fileItem.progress && (
//               <button
//                 onClick={() => onRemove(fileItem.name)}
//                 className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
//                 title="Remove file"
//               >
//                 <Trash2 className="w-4 h-4" />
//               </button>
//             )}
            
//             <button
//               onClick={handleUpload}
//               disabled={fileItem.uploaded || fileItem.progress}
//               className={`p-3 rounded-lg transition-all duration-200 ${
//                 fileItem.uploaded || fileItem.progress
//                   ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                   : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//               }`}
//               title={fileItem.uploaded ? 'File already uploaded' : 'Upload file'}
//             >
//               <Upload className="w-5 h-5" />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Custom hook to fetch project name
// const useProjectName = (projectId) => {
//   const [projectName, setProjectName] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectName = async () => {
//       if (!projectId) return;

//       try {
//         setIsLoading(true);
//         setError(null);
        
//         const data = await apiClient.get(`/api/projects/${projectId}/`, {
//           showToast: false,
//         });

//         setProjectName(data.name);
//       } catch (err) {
//         console.error('Error fetching project name:', err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchProjectName();
//   }, [projectId]);

//   return { projectName, isLoading, error };
// };

// // Custom hook to list files in directory
// const useFileList = (projectName) => {
//   const [files, setFiles] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchFiles = useCallback(async () => {
//     if (!projectName) return;

//     setIsLoading(true);
//     setError(null);

//     try {
//       // Construct the path properly - the API expects everything after /api/list/ as the path parameter
//       const listPath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version`;
      
//       const response = await apiClient.get(`/api/list/${listPath}`, {
//         showToast: false,
//         useOperational: true,
//       });

//       // Filter for STL files only - the files are in response.data.files
//       const stlFiles = response.data?.files?.filter(file => 
//         file.name.toLowerCase().endsWith('.stl')
//       ) || [];

//       setFiles(stlFiles);
//     } catch (err) {
//       console.error('Error fetching file list:', err);
//       setError(err.message);
//       setFiles([]);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [projectName]);

//   useEffect(() => {
//     fetchFiles();
//   }, [fetchFiles]);

//   return { files, isLoading, error, refetch: fetchFiles };
// };

// // Flexible file upload hook with customizable path
// const useCustomFileUpload = (projectId, projectName, options = {}) => {
//   const {
//     initialFiles = [
//       { name: 'surrounding_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Surrounding Buildings' },
//       { name: 'target_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Target Buildings' },
//       { name: 'terrain.stl', uploaded: false, file: null, progress: null, displayName: 'Terrain' },
//       { name: 'vegetation.stl', uploaded: false, file: null, progress: null, displayName: 'Vegetation' }
//     ],
    
//     pathTemplate = 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//     endpoint = '/api/files/upload-form',
//     fileExtensions = ['.stl'],
//     useOperational = true,
//     overwrite = true
//   } = options;

//   const [files, setFiles] = useState(initialFiles);

//   const allFilesUploaded = files.every(file => file.uploaded);
//   const uploadedCount = files.filter(file => file.uploaded).length;

//   const updateFileProgress = useCallback((fileName, progress) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, progress } : f));
//   }, []);

//   const markFileUploaded = useCallback((fileName, file) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: true, file, progress: 'Complete' } : f));
//   }, []);

//   const removeFile = useCallback((fileName) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: false, file: null, progress: null } : f));
//   }, []);

//   const uploadFile = useCallback(async (fileName, selectedFile) => {
//     if (!projectId) throw new Error('Project ID is missing');
//     if (!projectName) throw new Error('Project name is missing');
    
//     // Check file extension
//     const hasValidExtension = fileExtensions.some(ext => 
//       selectedFile.name.toLowerCase().endsWith(ext.toLowerCase())
//     );
//     if (!hasValidExtension) {
//       throw new Error(`Please select a valid file. Allowed extensions: ${fileExtensions.join(', ')}`);
//     }

//     updateFileProgress(fileName, 'Uploading file...');
    
//     // Generate destination path using template
//     const destPath = pathTemplate
//       .replace('${projectName}', projectName)
//       .replace('${fileName}', fileName)
//       .replace('${projectId}', projectId);
    
//     await apiClient.uploadFile(endpoint, selectedFile, {
//       destPath,
//       overwrite: overwrite.toString(),
//     }, {
//       useOperational,
//       showToast: false,
//     });

//     markFileUploaded(fileName, selectedFile);
//     setTimeout(() => updateFileProgress(fileName, null), 2000);
//   }, [projectId, projectName, updateFileProgress, markFileUploaded, pathTemplate, endpoint, fileExtensions, useOperational, overwrite]);

//   return { files, allFilesUploaded, uploadedCount, uploadFile, removeFile, setFiles };
// };

// const useToast = () => {
//   const [toast, setToast] = useState(null);

//   const showToast = useCallback((message, type = 'info') => {
//     setToast({ message, type });
//     if (type !== 'loading') {
//       setTimeout(() => setToast(null), 3000);
//     }
//   }, []);

//   const hideToast = useCallback(() => setToast(null), []);

//   return { toast, showToast, hideToast };
// };

// // Main Component
// const CheckOutputFilesPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();
//   const { toast, showToast, hideToast } = useToast();
  
//   // Use the project name hook
//   const { projectName, isLoading: isLoadingProject, error: projectError } = useProjectName(projectId);
  
//   // Use file list hook to get available files
//   const { files: availableFiles, isLoading: isLoadingFiles, error: filesError, refetch: refetchFiles } = useFileList(projectName);
  
//   // Use custom file upload hook with specific path for output files
//   const { files, allFilesUploaded, uploadedCount, uploadFile, removeFile } = useCustomFileUpload(
//     projectId, 
//     projectName, 
//     {
//       pathTemplate: 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//       endpoint: '/api/files/upload-form',
//       fileExtensions: ['.stl'],
//       useOperational: true,
//       overwrite: true
//     }
//   );
  
//   const [downloadingFiles, setDownloadingFiles] = useState(new Set());
//   const [isProcessing, setIsProcessing] = useState(false);

//   // Show error if project fetch fails
//   useEffect(() => {
//     if (projectError) {
//       showToast(`Error loading project: ${projectError}`, 'error');
//     }
//   }, [projectError, showToast]);

//   // Show error if file listing fails
//   useEffect(() => {
//     if (filesError) {
//       showToast(`Error loading files: ${filesError}`, 'error');
//     }
//   }, [filesError, showToast]);

//   const handleBackToMenu = useCallback(() => {
//     navigate(`/project-processing/${projectId}`);
//   }, [navigate, projectId]);

//   const handleDownloadFile = useCallback(async (fileName) => {
//     if (!projectName) {
//       showToast('Project name is missing', 'error');
//       return;
//     }

//     setDownloadingFiles(prev => new Set(prev).add(fileName));
//     showToast(`Downloading ${fileName}...`, 'loading');
    
//     try {
//       // Construct the file path properly for the download API
//       const filePath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}`;
      
//       const response = await fetch(`/api/files/download/${filePath}`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('token')}`, // Adjust based on your auth setup
//         },
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to download file: ${response.statusText}`);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       showToast(`${fileName} downloaded successfully!`, 'success');
//     } catch (error) {
//       console.error('Download failed:', error);
//       showToast(`Failed to download ${fileName}. Please try again.`, 'error');
//     } finally {
//       setDownloadingFiles(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(fileName);
//         return newSet;
//       });
//     }
//   }, [projectName, showToast]);

//   const handleRefreshFiles = useCallback(() => {
//     refetchFiles();
//     showToast('File list refreshed', 'success');
//   }, [refetchFiles, showToast]);

//   const handleFileUpload = useCallback(async (fileName, file) => {
//     try {
//       await uploadFile(fileName, file);
//       showToast(`${fileName} uploaded successfully!`, 'success');
//       // Refresh the file list after upload
//       setTimeout(() => refetchFiles(), 1000);
//     } catch (error) {
//       console.error('Error uploading STL file:', error);
//       showToast(`Failed to upload ${fileName}. Please try again.`, 'error');
//     }
//   }, [uploadFile, showToast, refetchFiles]);

//   const handleRemoveFile = useCallback((fileName) => {
//     removeFile(fileName);
//     showToast('File removed successfully.', 'success');
//   }, [removeFile, showToast]);

//   const handleNext = useCallback(async () => {
//     if (!allFilesUploaded) {
//       showToast('Please upload all files before proceeding.', 'error');
//       return;
//     }

//     setIsProcessing(true);
//     showToast('Processing files...', 'loading');

//     try {
//       await new Promise(resolve => setTimeout(resolve, 2000));
//       showToast('Files processed successfully!', 'success');
//       navigate(`/project-processing/${projectId}`);
//     } catch (error) {
//       console.error('Processing failed:', error);
//       showToast('Processing failed. Please try again.', 'error');
//     } finally {
//       setIsProcessing(false);
//     }
//   }, [allFilesUploaded, projectId, navigate, showToast]);

//   // Show loading state while fetching project name
//   if (isLoadingProject) {
//     return (
//       <MainLayout>
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//           <div className="max-w-4xl mx-auto">
//             <div className="text-center">
//               <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
//               <p className="text-slate-600">Loading project information...</p>
//             </div>
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//         {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
        
//         <div className="max-w-4xl mx-auto">
//           <PageHeader
//             icon={FileUp}
//             title="Check Output Files"
//             subtitle="Review, download, and upload your processed STL files to continue with the project workflow"
//             projectId={projectId}
//             projectName={projectName}
//           />

//           {/* Back Button */}
//           <div className="flex justify-center mb-8">
//             <button
//               onClick={handleBackToMenu}
//               className="group bg-white hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg border border-slate-200"
//             >
//               <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
//               BACK TO MENU
//             </button>
//           </div>

//           {/* Progress Overview */}
//           {uploadedCount > 0 && (
//             <SectionCard
//               title="Upload Progress"
//               icon={FileUp}
//               gradient="from-blue-600 to-indigo-600"
//             >
//               <ProgressBar uploadedCount={uploadedCount} totalFiles={files.length} />
//             </SectionCard>
//           )}

//           {/* Available Files Section */}
//           <SectionCard
//             title="Available Output Files"
//             icon={Download}
//             gradient="from-indigo-600 to-purple-600"
//           >
//             <div className="flex justify-between items-center mb-4">
//               <p className="text-slate-600">
//                 Download individual output files for review and modification.
//               </p>
//               <button
//                 onClick={handleRefreshFiles}
//                 disabled={isLoadingFiles}
//                 className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-all duration-200 disabled:opacity-50"
//               >
//                 <RefreshCw className={`w-4 h-4 ${isLoadingFiles ? 'animate-spin' : ''}`} />
//                 Refresh
//               </button>
//             </div>

//             {isLoadingFiles ? (
//               <div className="text-center py-8">
//                 <Loader className="w-6 h-6 text-blue-600 animate-spin mx-auto mb-2" />
//                 <p className="text-slate-600">Loading available files...</p>
//               </div>
//             ) : availableFiles.length > 0 ? (
//               <div className="space-y-3">
//                 {availableFiles.map((file, index) => (
//                   <DownloadFileItem 
//                     key={index} 
//                     file={file} 
//                     onDownload={handleDownloadFile}
//                     isDownloading={downloadingFiles.has(file.name)}
//                   />
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-8 text-slate-500">
//                 <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
//                 <p>No STL files found in the output directory.</p>
//                 <p className="text-sm mt-1">Files may still be processing or the directory may be empty.</p>
//               </div>
//             )}
//           </SectionCard>

//           {/* Upload Section */}
//           <SectionCard
//             title="Upload Modified Files"
//             icon={Upload}
//             gradient="from-purple-600 to-pink-600"
//           >
//             <div className="space-y-4">
//               {files.map((fileItem, index) => (
//                 <FileUploadItem 
//                   key={index} 
//                   fileItem={fileItem} 
//                   onUpload={handleFileUpload} 
//                   onRemove={handleRemoveFile} 
//                 />
//               ))}
//             </div>

//             {!allFilesUploaded && (
//               <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
//                 <div className="flex items-start gap-3">
//                   <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
//                   <div>
//                     <h4 className="font-semibold text-amber-800 mb-1">Upload Required</h4>
//                     <p className="text-amber-700 text-sm">
//                       Please upload all {files.length} STL files ({uploadedCount}/{files.length} completed) to continue to the next step.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </SectionCard>

//           {/* Next Button */}
//           <div className="text-center">
//             <button
//               onClick={handleNext}
//               disabled={!allFilesUploaded || isProcessing || !projectName}
//               className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
//             >
//               {isProcessing ? (
//                 <>
//                   <Loader className="w-5 h-5 animate-spin" />
//                   Processing Files...
//                 </>
//               ) : (
//                 <>
//                   {allFilesUploaded ? 'Continue to Next Step' : `Upload Remaining Files (${uploadedCount}/${files.length})`}
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default CheckOutputFilesPage;
// import React, { useState, useCallback, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { MainLayout } from '../layout/MainLayout';
// import { 
//   Download, 
//   Upload, 
//   CheckCircle, 
//   XCircle, 
//   Loader, 
//   FileText, 
//   ArrowLeft, 
//   ArrowRight,
//   AlertCircle,
//   Trash2,
//   FileUp,
//   FolderOpen,
//   RefreshCw
// } from 'lucide-react';
// import apiClient from '../utils/apiClient';
// import PrimaryButton from "../ui/PrimaryButton";
// import { ActionButton } from "../ui/ActionButton";
// import { Toast } from '../ui/Toast';

// // Reusable Components
// const PageHeader = ({ 
//   icon: Icon, 
//   title, 
//   subtitle, 
//   iconGradient = "from-blue-600 to-indigo-600",
//   projectId,
//   projectName
// }) => (
//   <div className="text-center mb-8">
//     <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
//       <Icon className="w-8 h-8 text-white" />
//     </div>
//     <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
//       {title}
//     </h1>
//     {projectId && (
//       <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg mb-3">
//         <FolderOpen className="w-4 h-4 text-blue-600" />
//         <span className="font-semibold text-blue-800">
//           Project: {projectName || projectId}
//         </span>
//       </div>
//     )}
//     <p className="text-base text-slate-600 max-w-2xl mx-auto">
//       {subtitle}
//     </p>
//   </div>
// );

// const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
//   <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6 ${className}`}>
//     <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
//       <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
//       <div className="relative z-10 flex items-center gap-3">
//         <Icon className="w-5 h-5 text-white" />
//         <h2 className="text-lg font-bold text-white">{title}</h2>
//       </div>
      
//       {/* Decorative Elements */}
//       <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
//       <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
//     </div>
    
//     <div className="p-6">
//       {children}
//     </div>
//   </div>
// );

// const ProgressBar = ({ uploadedCount, totalFiles }) => {
//   if (uploadedCount === 0) return null;
  
//   const percentage = (uploadedCount / totalFiles) * 100;
  
//   return (
//     <div className="mb-6">
//       <div className="flex justify-between items-center mb-3">
//         <span className="text-sm font-semibold text-slate-700">Upload Progress</span>
//         <span className="text-sm font-bold text-blue-600">{uploadedCount}/{totalFiles} files</span>
//       </div>
//       <div className="w-full bg-slate-200 rounded-full h-3 shadow-inner">
//         <div 
//           className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all duration-500 shadow-sm"
//           style={{ width: `${percentage}%` }}
//         />
//       </div>
//       <div className="text-center mt-2">
//         <span className="text-xs text-slate-500">{Math.round(percentage)}% Complete</span>
//       </div>
//     </div>
//   );
// };

// // New component for individual file download
// const DownloadFileItem = ({ file, onDownload, isDownloading }) => {
//   const getFileSize = (size) => {
//     if (!size) return 'Unknown size';
//     if (size < 1024) return `${size} B`;
//     if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
//     if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
//     return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Unknown date';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   return (
//     <div className="group border-2 border-slate-200 bg-white hover:border-slate-300 hover:shadow-md rounded-xl p-4 transition-all duration-200">
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{file.name}</div>
//             <div className="text-sm text-slate-500">
//               {getFileSize(file.size)} • Modified: {formatDate(file.lastModified)}
//             </div>
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => onDownload(file.name)}
//             disabled={isDownloading}
//             className={`p-3 rounded-lg transition-all duration-200 flex items-center gap-2 ${
//               isDownloading
//                 ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                 : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//             }`}
//             title="Download file"
//           >
//             {isDownloading ? (
//               <>
//                 <Loader className="w-4 h-4 animate-spin" />
//                 <span className="text-sm font-medium">Downloading...</span>
//               </>
//             ) : (
//               <>
//                 <Download className="w-4 h-4" />
//                 <span className="text-sm font-medium">Download</span>
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const FileUploadItem = ({ fileItem, onUpload, onRemove }) => {
//   const handleUpload = () => {
//     const input = document.createElement('input');
//     input.type = 'file';
//     input.accept = '.stl';
//     input.onchange = (e) => {
//       const file = e.target.files[0];
//       if (file) onUpload(fileItem.name, file);
//     };
//     input.click();
//   };

//   const getStatusDisplay = () => {
//     if (fileItem.progress === 'Complete') {
//       return {
//         icon: <CheckCircle className="w-5 h-5 text-green-600" />,
//         text: 'Uploaded',
//         color: 'text-green-600'
//       };
//     }
//     if (fileItem.progress === 'Failed') {
//       return {
//         icon: <XCircle className="w-5 h-5 text-red-600" />,
//         text: 'Failed',
//         color: 'text-red-600'
//       };
//     }
//     if (fileItem.progress) {
//       return {
//         icon: <Loader className="w-5 h-5 text-blue-600 animate-spin" />,
//         text: fileItem.progress,
//         color: 'text-blue-600'
//       };
//     }
//     return null;
//   };

//   const getCardStyle = () => {
//     if (fileItem.uploaded) return 'border-green-300 bg-green-50 shadow-md';
//     if (fileItem.progress) return 'border-blue-300 bg-blue-50 shadow-md';
//     return 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md';
//   };

//   const status = getStatusDisplay();

//   return (
//     <div className={`group border-2 rounded-xl p-4 transition-all duration-200 ${getCardStyle()}`}>
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4 flex-1">
//           <div className="p-2 bg-slate-100 rounded-lg">
//             <FileText className="w-5 h-5 text-slate-600" />
//           </div>
          
//           <div className="flex-1">
//             <div className="font-semibold text-slate-800">{fileItem.displayName}</div>
//             <div className="text-sm text-slate-500">{fileItem.name}</div>
//             {fileItem.file && (
//               <div className="text-xs text-slate-400 mt-1">
//                 {fileItem.file.name} ({(fileItem.file.size / (1024 * 1024)).toFixed(2)} MB)
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center gap-3">
//           {status && (
//             <div className="flex items-center gap-2">
//               {status.icon}
//               <span className={`text-sm font-medium ${status.color}`}>
//                 {status.text}
//               </span>
//             </div>
//           )}

//           <div className="flex items-center gap-2">
//             {fileItem.uploaded && !fileItem.progress && (
//               <button
//                 onClick={() => onRemove(fileItem.name)}
//                 className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
//                 title="Remove file"
//               >
//                 <Trash2 className="w-4 h-4" />
//               </button>
//             )}
            
//             <button
//               onClick={handleUpload}
//               disabled={fileItem.uploaded || fileItem.progress}
//               className={`p-3 rounded-lg transition-all duration-200 ${
//                 fileItem.uploaded || fileItem.progress
//                   ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
//                   : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
//               }`}
//               title={fileItem.uploaded ? 'File already uploaded' : 'Upload file'}
//             >
//               <Upload className="w-5 h-5" />
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Custom hook to fetch project name
// const useProjectName = (projectId) => {
//   const [projectName, setProjectName] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProjectName = async () => {
//       if (!projectId) return;

//       try {
//         setIsLoading(true);
//         setError(null);
        
//         const data = await apiClient.get(`/api/projects/${projectId}/`, {
//           showToast: false,
//         });

//         setProjectName(data.name);
//       } catch (err) {
//         console.error('Error fetching project name:', err);
//         setError(err.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchProjectName();
//   }, [projectId]);

//   return { projectName, isLoading, error };
// };

// // Custom hook to list files in directory
// const useFileList = (projectName) => {
//   const [files, setFiles] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchFiles = useCallback(async () => {
//     if (!projectName) return;

//     setIsLoading(true);
//     setError(null);

//     try {
//       // Construct the path properly - the API expects everything after /api/list/ as the path parameter
//       const listPath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version`;
      
//       const response = await apiClient.get(`/api/list/${listPath}`, {
//         showToast: false,
//         useOperational: true,
//       });

//       // Filter for STL files only - the files are in response.data.files
//       const stlFiles = response.data?.files?.filter(file => 
//         file.name.toLowerCase().endsWith('.stl')
//       ) || [];

//       setFiles(stlFiles);
//     } catch (err) {
//       console.error('Error fetching file list:', err);
//       setError(err.message);
//       setFiles([]);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [projectName]);

//   useEffect(() => {
//     fetchFiles();
//   }, [fetchFiles]);

//   return { files, isLoading, error, refetch: fetchFiles };
// };

// // Flexible file upload hook with customizable path
// const useCustomFileUpload = (projectId, projectName, options = {}) => {
//   const {
//     initialFiles = [
//       { name: 'surrounding_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Surrounding Buildings' },
//       { name: 'target_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Target Buildings' },
//       { name: 'terrain.stl', uploaded: false, file: null, progress: null, displayName: 'Terrain' },
//       { name: 'vegetation.stl', uploaded: false, file: null, progress: null, displayName: 'Vegetation' }
//     ],
    
//     pathTemplate = 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//     endpoint = '/api/files/upload-form',
//     fileExtensions = ['.stl'],
//     useOperational = true,
//     overwrite = true
//   } = options;

//   const [files, setFiles] = useState(initialFiles);

//   const allFilesUploaded = files.every(file => file.uploaded);
//   const uploadedCount = files.filter(file => file.uploaded).length;

//   const updateFileProgress = useCallback((fileName, progress) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, progress } : f));
//   }, []);

//   const markFileUploaded = useCallback((fileName, file) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: true, file, progress: 'Complete' } : f));
//   }, []);

//   const removeFile = useCallback((fileName) => {
//     setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: false, file: null, progress: null } : f));
//   }, []);

//   const uploadFile = useCallback(async (fileName, selectedFile) => {
//     if (!projectId) throw new Error('Project ID is missing');
//     if (!projectName) throw new Error('Project name is missing');
    
//     // Check file extension
//     const hasValidExtension = fileExtensions.some(ext => 
//       selectedFile.name.toLowerCase().endsWith(ext.toLowerCase())
//     );
//     if (!hasValidExtension) {
//       throw new Error(`Please select a valid file. Allowed extensions: ${fileExtensions.join(', ')}`);
//     }

//     updateFileProgress(fileName, 'Uploading file...');
    
//     // Generate destination path using template
//     const destPath = pathTemplate
//       .replace('${projectName}', projectName)
//       .replace('${fileName}', fileName)
//       .replace('${projectId}', projectId);
    
//     await apiClient.uploadFile(endpoint, selectedFile, {
//       destPath,
//       overwrite: overwrite.toString(),
//     }, {
//       useOperational,
//       showToast: false,
//     });

//     markFileUploaded(fileName, selectedFile);
//     setTimeout(() => updateFileProgress(fileName, null), 2000);
//   }, [projectId, projectName, updateFileProgress, markFileUploaded, pathTemplate, endpoint, fileExtensions, useOperational, overwrite]);

//   return { files, allFilesUploaded, uploadedCount, uploadFile, removeFile, setFiles };
// };

// const useToast = () => {
//   const [toast, setToast] = useState(null);

//   const showToast = useCallback((message, type = 'info') => {
//     setToast({ message, type });
//     if (type !== 'loading') {
//       setTimeout(() => setToast(null), 3000);
//     }
//   }, []);

//   const hideToast = useCallback(() => setToast(null), []);

//   return { toast, showToast, hideToast };
// };

// // Main Component
// const CheckOutputFilesPage = () => {
//   const { projectId } = useParams();
//   const navigate = useNavigate();
//   const { toast, showToast, hideToast } = useToast();
  
//   // Use the project name hook
//   const { projectName, isLoading: isLoadingProject, error: projectError } = useProjectName(projectId);
  
//   // Use file list hook to get available files
//   const { files: availableFiles, isLoading: isLoadingFiles, error: filesError, refetch: refetchFiles } = useFileList(projectName);
  
//   // Use custom file upload hook with specific path for output files
//   const { files, allFilesUploaded, uploadedCount, uploadFile, removeFile } = useCustomFileUpload(
//     projectId, 
//     projectName, 
//     {
//       pathTemplate: 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
//       endpoint: '/api/files/upload-form',
//       fileExtensions: ['.stl'],
//       useOperational: true,
//       overwrite: true
//     }
//   );
  
//   const [downloadingFiles, setDownloadingFiles] = useState(new Set());
//   const [isProcessing, setIsProcessing] = useState(false);

//   // Show error if project fetch fails
//   useEffect(() => {
//     if (projectError) {
//       showToast(`Error loading project: ${projectError}`, 'error');
//     }
//   }, [projectError, showToast]);

//   // Show error if file listing fails
//   useEffect(() => {
//     if (filesError) {
//       showToast(`Error loading files: ${filesError}`, 'error');
//     }
//   }, [filesError, showToast]);

//   const handleBackToMenu = useCallback(() => {
//     navigate(`/project-processing/${projectId}`);
//   }, [navigate, projectId]);

//   const handleDownloadFile = useCallback(async (fileName) => {
//     if (!projectName) {
//       showToast('Project name is missing', 'error');
//       return;
//     }

//     setDownloadingFiles(prev => new Set(prev).add(fileName));
//     showToast(`Downloading ${fileName}...`, 'loading');
    
//     try {
//       // Construct the file path properly for the download API
//       const filePath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}`;
      
//       // Try using fetch with proper authentication
//       // Get the auth token from wherever your app stores it
//       const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      
//       const response = await fetch(`/api/files/download/${filePath}`, {
//         method: 'GET',
//         headers: {
//           ...(token && { 'Authorization': `Bearer ${token}` }),
//           'Accept': 'application/octet-stream, */*',
//         },
//       });

//       console.log('Download response status:', response.status);
//       console.log('Download response headers:', Object.fromEntries(response.headers.entries()));

//       if (!response.ok) {
//         // Try to get error message from response
//         const errorText = await response.text();
//         console.error('Download error response:', errorText);
//         throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
//       }

//       // Check content type to make sure we got a file
//       const contentType = response.headers.get('content-type');
//       console.log('Content type:', contentType);

//       const blob = await response.blob();
//       console.log('Downloaded blob size:', blob.size, 'bytes');
      
//       // Check if blob is suspiciously small
//       if (blob.size < 100) {
//         console.warn('Blob size is very small, might be an error response');
//         // Convert blob to text to see what we actually got
//         const text = await blob.text();
//         console.log('Small blob content:', text);
//         throw new Error('Downloaded file appears to be corrupted or empty');
//       }

//       // Create download link
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       showToast(`${fileName} downloaded successfully!`, 'success');
//     } catch (error) {
//       console.error('Download failed:', error);
//       showToast(`Failed to download ${fileName}: ${error.message}`, 'error');
//     } finally {
//       setDownloadingFiles(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(fileName);
//         return newSet;
//       });
//     }
//   }, [projectName, showToast]);

//   const handleRefreshFiles = useCallback(() => {
//     refetchFiles();
//     showToast('File list refreshed', 'success');
//   }, [refetchFiles, showToast]);

//   const handleFileUpload = useCallback(async (fileName, file) => {
//     try {
//       await uploadFile(fileName, file);
//       showToast(`${fileName} uploaded successfully!`, 'success');
//       // Refresh the file list after upload
//       setTimeout(() => refetchFiles(), 1000);
//     } catch (error) {
//       console.error('Error uploading STL file:', error);
//       showToast(`Failed to upload ${fileName}. Please try again.`, 'error');
//     }
//   }, [uploadFile, showToast, refetchFiles]);

//   const handleRemoveFile = useCallback((fileName) => {
//     removeFile(fileName);
//     showToast('File removed successfully.', 'success');
//   }, [removeFile, showToast]);

//   const handleNext = useCallback(async () => {
//     if (!allFilesUploaded) {
//       showToast('Please upload all files before proceeding.', 'error');
//       return;
//     }

//     setIsProcessing(true);
//     showToast('Processing files...', 'loading');

//     try {
//       await new Promise(resolve => setTimeout(resolve, 2000));
//       showToast('Files processed successfully!', 'success');
//       navigate(`/project-processing/${projectId}`);
//     } catch (error) {
//       console.error('Processing failed:', error);
//       showToast('Processing failed. Please try again.', 'error');
//     } finally {
//       setIsProcessing(false);
//     }
//   }, [allFilesUploaded, projectId, navigate, showToast]);

//   // Show loading state while fetching project name
//   if (isLoadingProject) {
//     return (
//       <MainLayout>
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//           <div className="max-w-4xl mx-auto">
//             <div className="text-center">
//               <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
//               <p className="text-slate-600">Loading project information...</p>
//             </div>
//           </div>
//         </div>
//       </MainLayout>
//     );
//   }

//   return (
//     <MainLayout>
//       <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
//         {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
        
//         <div className="max-w-4xl mx-auto">
//           <PageHeader
//             icon={FileUp}
//             title="Check Output Files"
//             subtitle="Review, download, and upload your processed STL files to continue with the project workflow"
//             projectId={projectId}
//             projectName={projectName}
//           />

//           {/* Back Button */}
//           <div className="flex justify-center mb-8">
//             <button
//               onClick={handleBackToMenu}
//               className="group bg-white hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg border border-slate-200"
//             >
//               <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
//               BACK TO MENU
//             </button>
//           </div>

//           {/* Progress Overview */}
//           {uploadedCount > 0 && (
//             <SectionCard
//               title="Upload Progress"
//               icon={FileUp}
//               gradient="from-blue-600 to-indigo-600"
//             >
//               <ProgressBar uploadedCount={uploadedCount} totalFiles={files.length} />
//             </SectionCard>
//           )}

//           {/* Available Files Section */}
//           <SectionCard
//             title="Available Output Files"
//             icon={Download}
//             gradient="from-indigo-600 to-purple-600"
//           >
//             <div className="flex justify-between items-center mb-4">
//               <p className="text-slate-600">
//                 Download individual output files for review and modification.
//               </p>
//               <button
//                 onClick={handleRefreshFiles}
//                 disabled={isLoadingFiles}
//                 className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-all duration-200 disabled:opacity-50"
//               >
//                 <RefreshCw className={`w-4 h-4 ${isLoadingFiles ? 'animate-spin' : ''}`} />
//                 Refresh
//               </button>
//             </div>

//             {isLoadingFiles ? (
//               <div className="text-center py-8">
//                 <Loader className="w-6 h-6 text-blue-600 animate-spin mx-auto mb-2" />
//                 <p className="text-slate-600">Loading available files...</p>
//               </div>
//             ) : availableFiles.length > 0 ? (
//               <div className="space-y-3">
//                 {availableFiles.map((file, index) => (
//                   <DownloadFileItem 
//                     key={index} 
//                     file={file} 
//                     onDownload={handleDownloadFile}
//                     isDownloading={downloadingFiles.has(file.name)}
//                   />
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center py-8 text-slate-500">
//                 <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
//                 <p>No STL files found in the output directory.</p>
//                 <p className="text-sm mt-1">Files may still be processing or the directory may be empty.</p>
//               </div>
//             )}
//           </SectionCard>

//           {/* Upload Section */}
//           <SectionCard
//             title="Upload Modified Files"
//             icon={Upload}
//             gradient="from-purple-600 to-pink-600"
//           >
//             <div className="space-y-4">
//               {files.map((fileItem, index) => (
//                 <FileUploadItem 
//                   key={index} 
//                   fileItem={fileItem} 
//                   onUpload={handleFileUpload} 
//                   onRemove={handleRemoveFile} 
//                 />
//               ))}
//             </div>

//             {!allFilesUploaded && (
//               <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
//                 <div className="flex items-start gap-3">
//                   <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
//                   <div>
//                     <h4 className="font-semibold text-amber-800 mb-1">Upload Required</h4>
//                     <p className="text-amber-700 text-sm">
//                       Please upload all {files.length} STL files ({uploadedCount}/{files.length} completed) to continue to the next step.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </SectionCard>

//           {/* Next Button */}
//           <div className="text-center">
//             <button
//               onClick={handleNext}
//               disabled={!allFilesUploaded || isProcessing || !projectName}
//               className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
//             >
//               {isProcessing ? (
//                 <>
//                   <Loader className="w-5 h-5 animate-spin" />
//                   Processing Files...
//                 </>
//               ) : (
//                 <>
//                   {allFilesUploaded ? 'Continue to Next Step' : `Upload Remaining Files (${uploadedCount}/${files.length})`}
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
//                 </>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default CheckOutputFilesPage;
import React, { useState, useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MainLayout } from '../layout/MainLayout';
import { 
  Download, 
  Upload, 
  CheckCircle, 
  XCircle, 
  Loader, 
  FileText, 
  ArrowLeft, 
  ArrowRight,
  AlertCircle,
  Trash2,
  FileUp,
  FolderOpen,
  RefreshCw
} from 'lucide-react';
import apiClient from '../utils/apiClient';
import PrimaryButton from "../ui/PrimaryButton";
import { ActionButton } from "../ui/ActionButton";
import { Toast } from '../ui/Toast';

// Reusable Components
const PageHeader = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  iconGradient = "from-blue-600 to-indigo-600",
  projectId,
  projectName
}) => (
  <div className="text-center mb-8">
    <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${iconGradient} rounded-xl mb-4 shadow-lg`}>
      <Icon className="w-8 h-8 text-white" />
    </div>
    <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3">
      {title}
    </h1>
    {projectId && (
      <div className="inline-flex items-center gap-2 bg-blue-100 px-4 py-2 rounded-lg mb-3">
        <FolderOpen className="w-4 h-4 text-blue-600" />
        <span className="font-semibold text-blue-800">
          Project: {projectName || projectId}
        </span>
      </div>
    )}
    <p className="text-base text-slate-600 max-w-2xl mx-auto">
      {subtitle}
    </p>
  </div>
);

const SectionCard = ({ title, icon: Icon, gradient, children, className = "" }) => (
  <div className={`bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden mb-6 ${className}`}>
    <div className={`bg-gradient-to-r ${gradient} p-4 relative overflow-hidden`}>
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <Icon className="w-5 h-5 text-white" />
        <h2 className="text-lg font-bold text-white">{title}</h2>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    
    <div className="p-6">
      {children}
    </div>
  </div>
);

const ProgressBar = ({ uploadedCount, totalFiles }) => {
  if (uploadedCount === 0) return null;
  
  const percentage = (uploadedCount / totalFiles) * 100;
  
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm font-semibold text-slate-700">Upload Progress</span>
        <span className="text-sm font-bold text-blue-600">{uploadedCount}/{totalFiles} files</span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-3 shadow-inner">
        <div 
          className="bg-gradient-to-r from-blue-500 to-indigo-500 h-3 rounded-full transition-all duration-500 shadow-sm"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="text-center mt-2">
        <span className="text-xs text-slate-500">{Math.round(percentage)}% Complete</span>
      </div>
    </div>
  );
};

// New component for individual file download
const DownloadFileItem = ({ file, onDownload, isDownloading }) => {
  const getFileSize = (size) => {
    if (!size) return 'Unknown size';
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="group border-2 border-slate-200 bg-white hover:border-slate-300 hover:shadow-md rounded-xl p-4 transition-all duration-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 flex-1">
          <div className="p-2 bg-slate-100 rounded-lg">
            <FileText className="w-5 h-5 text-slate-600" />
          </div>
          
          <div className="flex-1">
            <div className="font-semibold text-slate-800">{file.name}</div>
            <div className="text-sm text-slate-500">
              {getFileSize(file.size)} • Modified: {formatDate(file.lastModified)}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => onDownload(file.name)}
            disabled={isDownloading}
            className={`p-3 rounded-lg transition-all duration-200 flex items-center gap-2 ${
              isDownloading
                ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
            }`}
            title="Download file"
          >
            {isDownloading ? (
              <>
                <Loader className="w-4 h-4 animate-spin" />
                <span className="text-sm font-medium">Downloading...</span>
              </>
            ) : (
              <>
                <Download className="w-4 h-4" />
                <span className="text-sm font-medium">Download</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

const FileUploadItem = ({ fileItem, onUpload, onRemove }) => {
  const handleUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.stl';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) onUpload(fileItem.name, file);
    };
    input.click();
  };

  const getStatusDisplay = () => {
    if (fileItem.progress === 'Complete') {
      return {
        icon: <CheckCircle className="w-5 h-5 text-green-600" />,
        text: 'Uploaded',
        color: 'text-green-600'
      };
    }
    if (fileItem.progress === 'Failed') {
      return {
        icon: <XCircle className="w-5 h-5 text-red-600" />,
        text: 'Failed',
        color: 'text-red-600'
      };
    }
    if (fileItem.progress) {
      return {
        icon: <Loader className="w-5 h-5 text-blue-600 animate-spin" />,
        text: fileItem.progress,
        color: 'text-blue-600'
      };
    }
    return null;
  };

  const getCardStyle = () => {
    if (fileItem.uploaded) return 'border-green-300 bg-green-50 shadow-md';
    if (fileItem.progress) return 'border-blue-300 bg-blue-50 shadow-md';
    return 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md';
  };

  const status = getStatusDisplay();

  return (
    <div className={`group border-2 rounded-xl p-4 transition-all duration-200 ${getCardStyle()}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 flex-1">
          <div className="p-2 bg-slate-100 rounded-lg">
            <FileText className="w-5 h-5 text-slate-600" />
          </div>
          
          <div className="flex-1">
            <div className="font-semibold text-slate-800">{fileItem.displayName}</div>
            <div className="text-sm text-slate-500">{fileItem.name}</div>
            {fileItem.file && (
              <div className="text-xs text-slate-400 mt-1">
                {fileItem.file.name} ({(fileItem.file.size / (1024 * 1024)).toFixed(2)} MB)
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          {status && (
            <div className="flex items-center gap-2">
              {status.icon}
              <span className={`text-sm font-medium ${status.color}`}>
                {status.text}
              </span>
            </div>
          )}

          <div className="flex items-center gap-2">
            {fileItem.uploaded && !fileItem.progress && (
              <button
                onClick={() => onRemove(fileItem.name)}
                className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200"
                title="Remove file"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            )}
            
            <button
              onClick={handleUpload}
              disabled={fileItem.uploaded || fileItem.progress}
              className={`p-3 rounded-lg transition-all duration-200 ${
                fileItem.uploaded || fileItem.progress
                  ? 'bg-slate-200 text-slate-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white hover:scale-105 shadow-md hover:shadow-lg'
              }`}
              title={fileItem.uploaded ? 'File already uploaded' : 'Upload file'}
            >
              <Upload className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Custom hook to fetch project name
const useProjectName = (projectId) => {
  const [projectName, setProjectName] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjectName = async () => {
      if (!projectId) return;

      try {
        setIsLoading(true);
        setError(null);
        
        const data = await apiClient.get(`/api/projects/${projectId}/`, {
          showToast: false,
        });

        setProjectName(data.name);
      } catch (err) {
        console.error('Error fetching project name:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjectName();
  }, [projectId]);

  return { projectName, isLoading, error };
};

// Custom hook to list files in directory
const useFileList = (projectName) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFiles = useCallback(async () => {
    if (!projectName) return;

    setIsLoading(true);
    setError(null);

    try {
      // Construct the path properly - the API expects everything after /api/list/ as the path parameter
      const listPath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version`;
      
      const response = await apiClient.get(`/api/list/${listPath}`, {
        showToast: false,
        useOperational: true,
      });

      console.log('File list response:', response);

      // Filter for STL files only - the files are in response.data.files
      const stlFiles = response.data?.files?.filter(file => 
        file.name.toLowerCase().endsWith('.stl')
      ) || [];

      console.log('STL files found:', stlFiles);
      setFiles(stlFiles);
    } catch (err) {
      console.error('Error fetching file list:', err);
      setError(err.message);
      setFiles([]);
    } finally {
      setIsLoading(false);
    }
  }, [projectName]);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  return { files, isLoading, error, refetch: fetchFiles };
};

// Flexible file upload hook with customizable path
const useCustomFileUpload = (projectId, projectName, options = {}) => {
  const {
    initialFiles = [
      { name: 'surrounding_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Surrounding Buildings' },
      { name: 'target_buildings.stl', uploaded: false, file: null, progress: null, displayName: 'Target Buildings' },
      { name: 'terrain.stl', uploaded: false, file: null, progress: null, displayName: 'Terrain' },
      { name: 'vegetation.stl', uploaded: false, file: null, progress: null, displayName: 'Vegetation' }
    ],
    
    pathTemplate = 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
    endpoint = '/api/files/upload-form',
    fileExtensions = ['.stl'],
    useOperational = true,
    overwrite = true
  } = options;

  const [files, setFiles] = useState(initialFiles);

  const allFilesUploaded = files.every(file => file.uploaded);
  const uploadedCount = files.filter(file => file.uploaded).length;

  const updateFileProgress = useCallback((fileName, progress) => {
    setFiles(prev => prev.map(f => f.name === fileName ? { ...f, progress } : f));
  }, []);

  const markFileUploaded = useCallback((fileName, file) => {
    setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: true, file, progress: 'Complete' } : f));
  }, []);

  const removeFile = useCallback((fileName) => {
    setFiles(prev => prev.map(f => f.name === fileName ? { ...f, uploaded: false, file: null, progress: null } : f));
  }, []);

  const uploadFile = useCallback(async (fileName, selectedFile) => {
    if (!projectId) throw new Error('Project ID is missing');
    if (!projectName) throw new Error('Project name is missing');
    
    // Check file extension
    const hasValidExtension = fileExtensions.some(ext => 
      selectedFile.name.toLowerCase().endsWith(ext.toLowerCase())
    );
    if (!hasValidExtension) {
      throw new Error(`Please select a valid file. Allowed extensions: ${fileExtensions.join(', ')}`);
    }

    updateFileProgress(fileName, 'Uploading file...');
    
    // Generate destination path using template
    const destPath = pathTemplate
      .replace('${projectName}', projectName)
      .replace('${fileName}', fileName)
      .replace('${projectId}', projectId);
    
    await apiClient.uploadFile(endpoint, selectedFile, {
      destPath,
      overwrite: overwrite.toString(),
    }, {
      useOperational,
      showToast: false,
    });

    markFileUploaded(fileName, selectedFile);
    setTimeout(() => updateFileProgress(fileName, null), 2000);
  }, [projectId, projectName, updateFileProgress, markFileUploaded, pathTemplate, endpoint, fileExtensions, useOperational, overwrite]);

  return { files, allFilesUploaded, uploadedCount, uploadFile, removeFile, setFiles };
};

const useToast = () => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
    if (type !== 'loading') {
      setTimeout(() => setToast(null), 3000);
    }
  }, []);

  const hideToast = useCallback(() => setToast(null), []);

  return { toast, showToast, hideToast };
};

// Main Component
const CheckOutputFilesPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { toast, showToast, hideToast } = useToast();
  
  // Use the project name hook
  const { projectName, isLoading: isLoadingProject, error: projectError } = useProjectName(projectId);
  
  // Use file list hook to get available files
  const { files: availableFiles, isLoading: isLoadingFiles, error: filesError, refetch: refetchFiles } = useFileList(projectName);
  
  // Use custom file upload hook with specific path for output files
  const { files, allFilesUploaded, uploadedCount, uploadFile, removeFile } = useCustomFileUpload(
    projectId, 
    projectName, 
    {
      pathTemplate: 'raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}',
      endpoint: '/api/files/upload-form',
      fileExtensions: ['.stl'],
      useOperational: true,
      overwrite: true
    }
  );
  
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());
  const [isProcessing, setIsProcessing] = useState(false);

  // Show error if project fetch fails
  useEffect(() => {
    if (projectError) {
      showToast(`Error loading project: ${projectError}`, 'error');
    }
  }, [projectError, showToast]);

  // Show error if file listing fails
  useEffect(() => {
    if (filesError) {
      showToast(`Error loading files: ${filesError}`, 'error');
    }
  }, [filesError, showToast]);

  const handleBackToMenu = useCallback(() => {
    navigate(`/project-processing/${projectId}`);
  }, [navigate, projectId]);

  const handleDownloadFile = useCallback(async (fileName) => {
    if (!projectName) {
      showToast('Project name is missing', 'error');
      return;
    }

    setDownloadingFiles(prev => new Set(prev).add(fileName));
    showToast(`Downloading ${fileName}...`, 'loading');
    
    try {
      // Construct the file path properly for your download API
      const filePath = `raytracing/raytracing/Projects/${projectName}/DigitalTwin/STLfiles/02_Final_version/${fileName}`;
      
      console.log('Downloading file from path:', filePath);
      
      // Get auth token - check multiple possible storage locations
      const token = localStorage.getItem('token') || 
                   sessionStorage.getItem('token') || 
                   localStorage.getItem('authToken') ||
                   localStorage.getItem('access_token');
      
      // Use full backend URL for download to avoid hitting frontend router
      const response = await fetch(`https://api.apps.leaftech.eu/api/files/download/${filePath}`, {
        method: 'GET',
        headers: {
          ...(token && { 'Authorization': `Bearer ${token}` }),
          'Accept': 'application/octet-stream, */*',
        },
      });

      console.log('Download response status:', response.status);
      console.log('Download response headers:', Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Download error response:', errorText);
        throw new Error(`Download failed: ${response.status} - ${errorText}`);
      }

      // Check content type to make sure we got a file and not HTML/JSON
      const contentType = response.headers.get('content-type');
      console.log('Content type:', contentType);
      
      if (contentType && (contentType.includes('text/html') || contentType.includes('application/json'))) {
        const errorText = await response.text();
        console.error('Got HTML/JSON instead of file:', errorText.substring(0, 500));
        throw new Error('Server returned an error page instead of the file. Check authentication.');
      }

      const blob = await response.blob();
      console.log('Downloaded blob size:', blob.size, 'bytes');
      
      // STL files should be larger than 2KB typically
      if (blob.size < 2000) {
        console.warn('File size seems very small for an STL file');
      }
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      showToast(`${fileName} downloaded successfully! (${(blob.size / 1024).toFixed(1)} KB)`, 'success');
    } catch (error) {
      console.error('Download failed:', error);
      showToast(`Failed to download ${fileName}: ${error.message}`, 'error');
    } finally {
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(fileName);
        return newSet;
      });
    }
  }, [projectName, showToast]);

  const handleRefreshFiles = useCallback(() => {
    refetchFiles();
    showToast('File list refreshed', 'success');
  }, [refetchFiles, showToast]);

  const handleFileUpload = useCallback(async (fileName, file) => {
    try {
      await uploadFile(fileName, file);
      showToast(`${fileName} uploaded successfully!`, 'success');
      // Refresh the file list after upload
      setTimeout(() => refetchFiles(), 1000);
    } catch (error) {
      console.error('Error uploading STL file:', error);
      showToast(`Failed to upload ${fileName}. Please try again.`, 'error');
    }
  }, [uploadFile, showToast, refetchFiles]);

  const handleRemoveFile = useCallback((fileName) => {
    removeFile(fileName);
    showToast('File removed successfully.', 'success');
  }, [removeFile, showToast]);

  const handleNext = useCallback(async () => {
    if (!allFilesUploaded) {
      showToast('Please upload all files before proceeding.', 'error');
      return;
    }

    setIsProcessing(true);
    showToast('Processing files...', 'loading');

    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      showToast('Files processed successfully!', 'success');
      navigate(`/project-processing/${projectId}`);
    } catch (error) {
      console.error('Processing failed:', error);
      showToast('Processing failed. Please try again.', 'error');
    } finally {
      setIsProcessing(false);
    }
  }, [allFilesUploaded, projectId, navigate, showToast]);

  // Show loading state while fetching project name
  if (isLoadingProject) {
    return (
      <MainLayout>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center">
              <Loader className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
              <p className="text-slate-600">Loading project information...</p>
            </div>
          </div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
        {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}
        
        <div className="max-w-4xl mx-auto">
          <PageHeader
            icon={FileUp}
            title="Check Output Files"
            subtitle="Review, download, and upload your processed STL files to continue with the project workflow"
            projectId={projectId}
            projectName={projectName}
          />

          {/* Back Button */}
          <div className="flex justify-center mb-8">
            <button
              onClick={handleBackToMenu}
              className="group bg-white hover:bg-slate-50 text-slate-700 px-6 py-3 rounded-xl font-semibold transition-all duration-200 flex items-center gap-3 shadow-md hover:shadow-lg border border-slate-200"
            >
              <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform duration-200" />
              BACK TO MENU
            </button>
          </div>

          {/* Progress Overview */}
          {uploadedCount > 0 && (
            <SectionCard
              title="Upload Progress"
              icon={FileUp}
              gradient="from-blue-600 to-indigo-600"
            >
              <ProgressBar uploadedCount={uploadedCount} totalFiles={files.length} />
            </SectionCard>
          )}

          {/* Available Files Section */}
          <SectionCard
            title="Available Output Files"
            icon={Download}
            gradient="from-indigo-600 to-purple-600"
          >
            <div className="flex justify-between items-center mb-4">
              <p className="text-slate-600">
                Download individual output files for review and modification.
              </p>
              <button
                onClick={handleRefreshFiles}
                disabled={isLoadingFiles}
                className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-all duration-200 disabled:opacity-50"
              >
                <RefreshCw className={`w-4 h-4 ${isLoadingFiles ? 'animate-spin' : ''}`} />
                Refresh
              </button>
            </div>

            {isLoadingFiles ? (
              <div className="text-center py-8">
                <Loader className="w-6 h-6 text-blue-600 animate-spin mx-auto mb-2" />
                <p className="text-slate-600">Loading available files...</p>
              </div>
            ) : availableFiles.length > 0 ? (
              <div className="space-y-3">
                {availableFiles.map((file, index) => (
                  <DownloadFileItem 
                    key={index} 
                    file={file} 
                    onDownload={handleDownloadFile}
                    isDownloading={downloadingFiles.has(file.name)}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-slate-500">
                <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
                <p>No STL files found in the output directory.</p>
                <p className="text-sm mt-1">Files may still be processing or the directory may be empty.</p>
              </div>
            )}
          </SectionCard>

          {/* Upload Section */}
          <SectionCard
            title="Upload Modified Files"
            icon={Upload}
            gradient="from-purple-600 to-pink-600"
          >
            <div className="space-y-4">
              {files.map((fileItem, index) => (
                <FileUploadItem 
                  key={index} 
                  fileItem={fileItem} 
                  onUpload={handleFileUpload} 
                  onRemove={handleRemoveFile} 
                />
              ))}
            </div>

            {!allFilesUploaded && (
              <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-semibold text-amber-800 mb-1">Upload Required</h4>
                    <p className="text-amber-700 text-sm">
                      Please upload all {files.length} STL files ({uploadedCount}/{files.length} completed) to continue to the next step.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </SectionCard>

          {/* Next Button */}
          <div className="text-center">
            <button
              onClick={handleNext}
              disabled={!allFilesUploaded || isProcessing || !projectName}
              className="group bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-12 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center gap-3 mx-auto"
            >
              {isProcessing ? (
                <>
                  <Loader className="w-5 h-5 animate-spin" />
                  Processing Files...
                </>
              ) : (
                <>
                  {allFilesUploaded ? 'Continue to Next Step' : `Upload Remaining Files (${uploadedCount}/${files.length})`}
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default CheckOutputFilesPage;